import { FC } from "react";
import { NodeProps } from "reactflow";
import { StepDto, StepExecutionDto } from "../../../../../dtos";
import { ReactComponent as Split } from '../../../Assets/Split.svg';
import { PlayViewerNode } from "../../Components/PlayViewerNode";
import { PARALLEL_NODE_DESCRIPTION } from "../../utils";

export const ParallelPlayViewerNode: FC<NodeProps<StepDto | StepExecutionDto>> = (props) => {
    return <PlayViewerNode {...props} icon={<Split height='25px' width='25px' fill='currentColor' style={{ margin: '5px', transform: 'rotate(90deg)' }} />} description={PARALLEL_NODE_DESCRIPTION} disableEdit disableViewExecutionDetails />;
}